import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleRadio.svg",
  "use": "CircleRadio.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"CircleRadio.svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 12C3 16.9706 7.02945 21 12 21C16.9705 21 21 16.9706 21 12C21 7.02945 16.9705 3 12 3C7.02945 3 3 7.02945 3 12ZM12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol